import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import {
  ManagementPartyDto,
  UpdatePartyRequest,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'

export const PartyManagementOperations = {
  GetAll: 'PartyManagementOperations-GetAll',
  Add: 'PartyManagementOperations-Add',
  Update: 'PartyManagementOperations-Update',
  Delete: 'PartyManagementOperations-Delete',
}

export class PartyManagementController extends InternalAPI {
  constructor(private onRequestChange?: OnRequestChangeCallback) {
    super('/api/system/partymanagement')
  }

  public GetAll() {
    return this.GetAsync<ManagementPartyDto[]>({
      id: PartyManagementOperations.GetAll,
      relativePath: '/GetParties',
      onRequestChange: this.onRequestChange,
    })
  }

  public Add(partyDto: ManagementPartyDto) {
    return this.PostAsync<ManagementPartyDto>({
      id: PartyManagementOperations.Add,
      relativePath: '',
      data: partyDto,
      onRequestChange: this.onRequestChange,
    })
  }

  public Update(partyDto: ManagementPartyDto) {
    const data: UpdatePartyRequest = {
      partyId: partyDto.id,
      name: partyDto.name,
      coCKey: partyDto.coCKey,
      hasSubscription: partyDto.hasSubscription
    }

    return this.PutAsync<ManagementPartyDto>({
      id: PartyManagementOperations.Update,
      relativePath: '',
      data,
      onRequestChange: this.onRequestChange,
    })
  }

  public Delete(partyId: string) {
    return this.DeleteAsync({
      id: PartyManagementOperations.Delete,
      relativePath: '',
      data: { partyId },
      onRequestChange: this.onRequestChange,
    })
  }
}
